import { FC, useState } from 'react';
import DataRow from '@/libs/antd/components/DataRow';
import FleetModal from '@/libs/antd/components/Modal';
import FleetTitle from '@/libs/antd/components/Title';
import { ProspectEmploymentContract } from '@/libs/fleet-api/services/types';
import { useModals } from './ModalProvider';
import { formatCurrency } from '@/libs/antd/formater';
import dayjs from 'dayjs';
import { MasterData } from '@/libs/fleet-api/services/master-data';

export type EmploymentContractModalState = null | {
	employmentContract: ProspectEmploymentContract & {
		paymentMethodValue?: MasterData;
	};
};

export type EmploymentContractModalProps = {
	modal: EmploymentContractModalState;
	onClose: () => void;
};

const EmploymentContractModal: FC<EmploymentContractModalProps> = ({
	modal,
	onClose,
}) => {
	const { openPreviewModal } = useModals();
	const {
		bouwheer,
		contractDocument,
		// industrySector,
		jobTitle,
		spkNumber,
		jobLocation,
		contractDetail,
		contractValue,
		startDate,
		endDate,
		termOfPayment,
		tenor,
		paymentMethodValue,
	} = modal?.employmentContract ?? {};

	return (
		<FleetModal
			open={Boolean(modal)}
			width={940}
			cancelText="BACK"
			buttonPosition="end"
			closable={false}
			okButtonProps={{
				hidden: true,
			}}
			onCancel={() => onClose?.()}
		>
			<FleetTitle>Detil Kontrak Kerja</FleetTitle>
			<DataRow
				items={[
					[
						['Bouwheer Name', bouwheer?.name],
						['Bouwheer Type', bouwheer?.type],
					],
					[
						['Kelas Industri', bouwheer?.industrySector?.industryClass],
						['Sektor LV 5', bouwheer?.industrySector?.sectorLevel5],
					],
					[
						['Sektor LV 4', bouwheer?.industrySector?.sectorLevel4],
						['Sektor LV 3', bouwheer?.industrySector?.sectorLevel3],
					],
					[
						['Sektor LV 2', bouwheer?.industrySector?.sectorLevel2],
						['Sektor LV 1', bouwheer?.industrySector?.sectorLevel1],
					],
					[
						['Nama Pekerjaan', jobTitle],
						['No. SPK', spkNumber],
					],
					[
						['Lokasi Pekerjaan', jobLocation],
						[' ', ' '],
						// ['Term Of Payment', termOfPayment],
					],
					[
						['Detail Kontrak', contractDetail],
						[' ', ' '],
					],
					[
						['Nilai Kontrak', formatCurrency(contractValue)],
						[
							'View Dokumen',
							<a
								href="#"
								className="trigger-popup"
								onClick={(e) => {
									e.preventDefault();
									if (!contractDocument) return;
									openPreviewModal({
										name: contractDocument.name,
										url: contractDocument.url,
										id: contractDocument.id as unknown as number,
									});
								}}
							>
								View Dokumen
							</a>,
						],
					],
					[
						['Tanggal Mulai', dayjs(startDate).format('DD/MM/YYYY')],
						['Tanggal Berakhir', dayjs(endDate).format('DD/MM/YYYY')],
					],
					[
						['Tenor', tenor],
						['Sistem Pembayaran', paymentMethodValue?.value],
					],
					[['TOP Pembayaran', termOfPayment]],
				]}
				style={{
					marginBottom: 20,
				}}
			/>
		</FleetModal>
	);
};

export default EmploymentContractModal;

export const useEmploymentContractModal = () => {
	return useState<EmploymentContractModalState>(null);
};
